var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('product-dialog', { attrs: { "visible": _vm.dialogVisible, "action": _vm.makerType, "drawerLoading": _vm.loading, "formItemInfo": _vm.formItemInfo }, on: { "save-version-edit": _vm.saveVersionEdit, "initForm": _vm.initForm } });
};
var staticRenderFns = [];

export { render, staticRenderFns };